// Map blank card images to product code
export const CardImagesMap = {
  CCAU28D: "Card-Latitude28DegreesGlobalPlatinumMastercard.png",
  CCAUGEM: "Card-LatitudeGemVisa.png",
  CCAUGOM: "Card-GoMastercard.png",
  CCAUGOP: "Card-GoPlatinumMastercard.png",
  // TODO: Remove below code duplicated by above when the API is at parity
  CCAUGOB: "Card-GoPlatinumMastercard.png",
  CCAUAFS: "Card-CreditLineAppleFinancialServices.png",
  CCAULRM: "Card-LatitudeLowRateMastercard.png",
  CCAULIP: "Card-LatitudeInfinityRewardsVisa.png",
  // TODO: Remove below code duplicated by above when the API is at parity
  CCAUAFF: "Card-LatitudeInfinityRewardsVisa.png",
  CCAULMC: "Card-Latitude.png",
  CCAUECO: "Card-LatitudeEcoMastercard.png",
  CCAUCLN: "Card-CreditLine.png",
  CCAUBE: "Card-BuyersEdge.png",
  CCAUCCD: "Card-CareCredit.png",
  // TODO: Replace Gem Visa(NZ) card image when available
  CCNZGEM: "Card-GemVisa.png",
  CCNZOCV: "Card-GemEssential.png",
  CCNZCLN: "Card-GemCreditLine.png",
};
